import MentorReportsPage from './mentor-reports-page'

export default MentorReportsPage
